module.exports = __webpack_public_path__ + "static/media/picture.e66dba65.svg";